// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch--3-Kmz","selected":"selected--3xQ3n","blackFriday2019":"blackFriday2019--3cvcD"};